<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <!-- Header -->
    <div
        class="flex-0 flex flex-row items-center justify-between gap-x-4 w-full border-b border-zinc-200 dark:border-zinc-800 pb-2">
        <div class="flex flex-row items-center gap-x-4">
            <button (click)="backToBriefs()" type="button" class="btn-fab-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-5">
                    <path d="m12 19-7-7 7-7" />
                    <path d="M19 12H5" />
                </svg>
            </button>

            <div class="">
                <div class="inline-flex gap-x-2">
                    <h3 class="text-md font-semibold text-primary">{{
                        focussedScreeningBrief()?.briefTitle || 'Loading...' }}
                    </h3>
                </div>
                <p class="mt-0 text-xs text-secondary">Results for Screening Brief</p>
            </div>
        </div>

        <div class="flex flex-row items-center gap-x-2">
            <div class="hidden sm:block">
                <nav aria-label="Tabs" class="flex space-x-4">
                    <a (click)="selectTab('creators')" class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('creators')">Creators</a>
                    <a (click)="selectTab('brief-details')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('brief-details')">Brief Details</a>
                    <a (click)="selectTab('brief-management')"
                        class="rounded-md px-3 py-2 text-sm font-medium cursor-pointer"
                        [class]="getTabClass('brief-management')">Brief Management</a>
                </nav>
            </div>

        </div>

    </div>
    <!-- Header - END-->

    <!-- Content -->
    @if (focussedScreeningBrief()) {
    <div
        class="flex-1 flex flex-col justify-start items-center overflow-y-auto overflow-x-hidden w-full scrollbar-transparent">
        @switch (selectedTab()) {
        @case ('creators') {
            @if (focussedCreatorList()) {
                <sbr-creators [focussedScreeningBrief]="focussedScreeningBrief()!" [focussedCreatorList]="focussedCreatorList()!"></sbr-creators>
            } @else {
                Loading creator list...
            }
        }
        @case ('brief-details') {
            @if (focussedScreeningBrief()) {
                <sbr-brief-details [briefId]="focussedScreeningBrief()!.id"></sbr-brief-details>
            } @else {
                Loading brief details...
            }
        }
        @case ('brief-management') {
        <sbr-brief-management></sbr-brief-management>
        }
        }
    </div>
    } @else {
        Loading screening brief...
    }

    <!-- Content - END -->